<script>
import MainContainer from '../Components/UI/Content/MainContainer.vue'
import BlockContent from '../Components/UI/Content/BlockContent.vue'
import DataTable from '../Components/UI/Table/DataTable.vue'
import EntityQuickView from '../Components/Entity/EntityQuickView.vue'
import PageLayout from '../Components/UI/PageLayout.vue'
import mixinComponent from '../Mixins/mixinComponent'
import { globalVariablesMixin } from '../Mixins/global'
import EntityModal from '../Components/Entity/EntityModal.vue'
import { isTheme } from '../Utils/isTheme'

export default {
  components: { PageLayout, EntityQuickView, DataTable, EntityModal, BlockContent, MainContainer },
  mixins: [mixinComponent, globalVariablesMixin],
  data() {
    return {
      menu: 'societes-index',
      id: null,
      entity: {},
      contracts: {},
      loading: false,
      financialView: false,
      entityView: false,
    }
  },
  computed: {
    columnsSociety() {
      let columns = [
        {
          name: 'name',
          title: this.$t('entity.name'),
          formatter: 'entity',
          className: 'text-left',
          options: { renderType: 'entity', renderId: 'id' },
        },
        { name: 'siren', title: this.$t('entity.siren'), className: 'text-left' },
        { name: 'createdAt', displayable: false },
        {
          name: 'id',
          displayable: !this.isReadOnly && this.isNovalend,
          title: this.$t('entity.view'),
          className: 'text-center',
          formatter: 'action',
          options: { renderType: 'lookup' },
        },
        { name: 'accountCode', displayable: false },
        { name: 'accountCodeSup', displayable: false },
      ]
      if (this.hasRole('ROLE_INVOICE_ENTITY')) {
        columns.splice(2, 0, {
          name: 'totalNetBalance',
          displayable: true,
          title: this.$t('entity.totalNetBalance'),
          style: {
            className: 'col-align-right',
          },
          type: 'num-fmt',
          formatter: 'currency',
        })
      }
      return columns
    },

    columnsFinancialEvents() {
      return [
        { name: 'ruleCode', title: this.$t('financialEvent.list.ruleCode'), className: 'text-left' },
        {
          name: 'createdAt',
          title: this.$t('financialEvent.list.createdAt'),
          formatter: 'date',
          type: 'date',
          style: { className: 'text-left' },
        },
        {
          name: 'occurredAt',
          title: this.$t('financialEvent.list.occurredAt'),
          formatter: 'date',
          type: 'date',
          style: { className: 'text-left' },
        },
        { name: 'summary', title: this.$t('financialEvent.list.summary'), style: { className: 'text-left' } },
        { name: 'source', title: this.$t('financialEvent.list.source'), style: { className: 'text-left' } },
        {
          name: 'name',
          title: this.$t('financialEvent.list.entityName'),
          style: { className: 'text-left' },
          formatter: 'entity',
          options: { renderType: 'entity', renderId: 'entityId' },
        },
        {
          name: 'id',
          displayable: !this.isReadOnly() && isTheme('novalend'),
          title: this.$t('entity.view'),
          style: { className: 'text-center' },
          formatter: 'action',
          options: { renderType: 'lookup' },
        },
      ]
    },
    isNovalend() {
      return isTheme('novalend')
    },
    splitScreenClass() {
      return {
        'col-md-6': this.isNovalend,
      }
    },
    isReadonly() {
      return this.user.isReadOnly
    },
  },
  methods: {
    async getEntities(callback, { page, limit, search, sort = [] }) {
      const searchParams = new URLSearchParams()
      searchParams.set('page', page)
      searchParams.set('limit', limit)
      for (const { field, order } of sort) {
        searchParams.set(`sort[${field}]`, order)
      }
      if (!!search) {
        searchParams.set('q', search)
      }
      const { items: entities, total } = await this.getJSON(`entities/list?${searchParams.toString()}`)
      callback({ data: entities, recordsTotal: total, recordsFiltered: total })
    },
    getFinancialEvents(callback) {
      return this.getJSON('financialevents/list').then((financialEvents) => {
        callback({ data: financialEvents })
      })
    },
    onEntityCreated(entity) {
      this.$refs.listeSociete.renderDataTable()
      this.showEntityDetail(entity.id)
    },
    showEntityDetail(entityId) {
      this.financialView = false
      this.id = entityId
      this.loading = true
      this.getJSON('entities/' + this.id).then((json) => {
        this.entityView = true
        this.entity = json.entity
        this.contracts = json.contracts
        this.loading = false
        this.$nextTick(() => {
          this.$refs.view.scoreShow()
        })
      })
    },
  },
  mounted() {
    if (!this.hasRole('ROLE_APP_ADMIN_ENTITY_FULL')) {
      window.location = '/'
    }

    $('#listeSociete tbody').on('click', 'tr i', (e) => {
      this.showEntityDetail(e.target.id)
    })

    $('#listeFinanceEvent tbody').on('click', 'tr i', (e) => {
      this.showEntityDetail(e.target.id)
    })
  },
}
</script>
<template>
  <PageLayout menu="societes-index">
    <MainContainer>
      <div :class="{ row: isNovalend }">
        <div :class="splitScreenClass">
          <BlockContent v-if="financialView">
            <div class="d-flex justify-content-end">
              <div class="circle-icon" @click="financialView = !financialView">
                <i class="circle-icon-element fas fa-times"></i>
              </div>
            </div>
            <EntityQuickView ref="view" :loading="loading" :entity="entity" :contracts="contracts" />
          </BlockContent>
          <BlockContent v-else>
            <template #header-title>
              <div class="d-flex justify-content-between">
                <h4>{{ $t('menu.society') }}</h4>
                <EntityModal @submitted="onEntityCreated" />
              </div>
            </template>
            <DataTable
              id="listeSociete"
              ref="listeSociete"
              :columns="columnsSociety"
              :fetch="getEntities"
              :order="[{ dir: 'asc', name: 'name' }]"
              :zero-records="$t('entity.list.zeroRecords')"
              pagination-mode="server"
            />
          </BlockContent>
        </div>
        <div v-if="isNovalend" :class="splitScreenClass">
          <BlockContent v-if="entityView">
            <div class="d-flex justify-content-end">
              <div class="circle-icon" @click="entityView = !entityView">
                <i class="circle-icon-element fas fa-times"></i>
              </div>
            </div>
            <EntityQuickView ref="view" :loading="loading" :entity="entity" :contracts="contracts" />
          </BlockContent>
          <BlockContent title-t="menu.financialEvent" v-else>
            <DataTable
              id="listeFinancialEvents"
              :columns="columnsFinancialEvents"
              :fetch="getFinancialEvents"
              :order="[[2, 'desc']]"
              :zero-records="$t('entity.list.zeroRecords')"
            />
          </BlockContent>
        </div>
      </div>
    </MainContainer>
  </PageLayout>
</template>
